import Menu from '@/api/QMenuItem'

const getDefaultState = () => {
  return {
    currentMenu: {},
    menus: [],
  }
}

// initial state
const state = getDefaultState()

const getters = {}

const actions = {
  // async functions trow errors to view
  async ADD_MENU({ dispatch, rootState }, menu) {
    await Menu.post(rootState.sitePath, menu)
    dispatch('GET_MENUS')
  },

  async DELETE_MENU({ dispatch, rootState }, menu) {
    await Menu.delete(rootState.sitePath, menu.id)
    dispatch('GET_MENUS')
  },

  async UPDATE_MENU({ dispatch, rootState }, menu) {
    await Menu.put(rootState.sitePath, menu.id, menu)
    dispatch('GET_MENUS')
  },

  async COPY_FROM_PARENT({ dispatch, rootState }) {
    await Menu.copyFromParent(rootState.sitePath)
    dispatch('GET_MENUS')
  },

  async GET_MENU({ commit, rootState }, id) {
    const response = await Menu.put(rootState.sitePath, id)
    commit('SET_CURRENT_MENU', response.data)
  },

  async GET_MENUS({ commit, rootState }) {
    try {
      const response = await Menu.getQMenuItemsFull(rootState.sitePath)
      commit('SET_MENUS', response)
    } catch (error) {
      commit(
        'SHOW_ALERT',
        `Error ${error.response.status} getting list of Menus`,
        { root: true },
      )
    }
  },
}

const mutations = {
  SET_CURRENT_MENU(state, menu) {
    state.currentMenu = menu
  },

  SET_MENUS(state, menus) {
    var tmpMenus = []
    flatten(tmpMenus, menus, 0)
    state.menus = tmpMenus
  },
}

/* Calls itself to flatten the menus tree */
function flatten(state, menus, level) {
  menus.map(menu => {
    menu.indent = level
    state.push(menu)
    if (menu.items && menu.items.length) flatten(state, menu.items, level + 1)
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
